// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"98c78278","439":"765bb938","482":"b020c4dc","538":"9f590961","588":"0d250229","592":"9dfc57ee","599":"bbac9c2e","675":"43f5ce47","678":"bc69194a","800":"b7152c7d","818":"d804d738","852":"8710e5ce","971":"a4c645ca","991":"446475ef"}[chunkId] + ".chunk.js";
};